/**
 * Format a number as a currency string
 * @param {number} amount - The amount to format
 * @param {string} currencyCode - Currency code (default 'USD')
 * @param {string} locale - Locale to use for formatting (default 'en-US')
 * @returns {string} Formatted price string
 */
export const formatCurrency = (amount, currencyCode = 'USD', locale = 'en-US') => {
  if (typeof amount !== 'number' || isNaN(amount)) {
    return '$0.00';
  }
  
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  } catch (error) {
    // Fallback to simple formatting if Intl is not supported
    return `$${amount.toFixed(2)}`;
  }
};

/**
 * Format price as a decimal string without currency symbol
 * @param {number} price - The price to format
 * @returns {string} Price formatted with 2 decimal places
 */
export const formatPrice = (price) => {
  if (typeof price !== 'number' || isNaN(price)) {
    return '0.00';
  }
  return price.toFixed(2);
};

/**
 * Calculate the sum of an array of prices
 * @param {number[]} prices - Array of price values
 * @returns {number} The total amount
 */
export const sumPrices = (prices) => {
  if (!Array.isArray(prices) || prices.length === 0) {
    return 0;
  }
  
  return prices.reduce((total, price) => 
    total + (typeof price === 'number' ? price : 0), 0);
};